import React from 'react'
import Notifications from '../../components/views/Settings/Notifications'

export default function NotificationsScreen(props) {
  return <Notifications type={props.route.params.id} />
}
